import ConnectedDashboards from './ConnectedDashboards';

export default ConnectedDashboards;
